module.exports = __webpack_public_path__ + "d5be176615812617ca64f01c069a4c81.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/helmet-football-s.png
// module id = 2924
// module chunks = 0